import { useEffect, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { ROUTES } from "../utils/Routes";
import { listen } from "../hooks/Listener";
import { createModal } from "../hooks/createModal";
import Menu from "../ui/Menu";
import Card from "../ui/Card";
import Label from "../ui/Label";
import ReportsCustomInventory from "../components/ReportsCustomInventory";
import { drawPicker } from "../popovers/Picker";
import ReportsInventoryReportViewer from "../components/ReportsInventoryReportViewer";

export default function ReportsController(props) {


    const { controller = "", is_modal = false, signal = {}, search = "", callback = () => { }, setController = () => { } } = props;

    const route = ROUTES.REPORTS.REPORTS;

    const [selected, setSelected] = useState("1");
    const [state, setState] = useState({ view: "reports", variant: "" });




    const selectInventoryReport = () => {

        const options = [
            { label: "Inventory stats (activity by month)", value: "a", key: KBD.A },
            { label: "Mid-Month Inventory totals", value: "b", key: KBD.B },
            { label: "Month-end Inventory totals (updated by Month-end)", value: "c", key: KBD.C },
            { label: "Inventory performance report", value: "d", key: KBD.D },
            { label: "Negative On-Hand", value: "00000000-0000-0000-0000-000000000001", key: KBD.E },
            { label: "Items with more than 100 On-Hand", value: "f", key: KBD.F },
            { label: "Items over $100", value: "g", key: KBD.G },
            { label: "Items in stock for over 12 months", value: "h", key: KBD.H },
            { label: "Items with no invoice history (updated by b) above)", value: "i", key: KBD.I },
            { label: "Suggested overstock returns", value: "j", key: KBD.J },
            { label: "Backroom stock needed on floor", value: "00000000-0000-0000-0000-000000000002", key: KBD.K },
            { label: "Pubstock fast-seller reorder report", value: "l", key: KBD.L },
            { label: "Suggested Inventory deletions", value: "m", key: KBD.M },
            { label: "Publication date updates via TitleLink", value: "n", key: KBD.N },
            { label: "Forthcoming title price differences", value: "o", key: KBD.O }
        ];

        drawPicker({
            controller: controller,
            show_keys: true,
            title: "2) Inventory Reports", closeable: true, height: 300, route: route, callback: (e) => {

                if (e) {
                    switchView("inventory_reports", e);
                }

            }, offset: [0, 10],
            options: options
        })


    }



    const switchView = (_view, _variant) => {

        switch (_view) {
            case "custom_inventory_reports":
                window.bm_state.value = ROUTES.REPORTS.CUSTOM_INVENTORY;
                break;
            case "inventory_reports":
                window.bm_state.value = ROUTES.REPORTS.INVENTORY_REPORT_VIEWER;
                break;
            default:
                window.bm_state.value = ROUTES.REPORTS.REPORTS;
                break;
        }
        setState({ ...state, view: _view, variant : _variant });
    }

    const menu = [
        { text: "Custom Inventory Reports", key: KBD.Digit1, option: "custom_inventory_reports", action: () => switchView("custom_inventory_reports") },
        {  disabled: true, text: "Inventory Reports", key: KBD.Digit2, option: "inventory_reports" },
        { disabled: true, text: "Sales Reports", key: KBD.Digit3, option: "3" },
        { disabled: true, text: "Orders Reports", key: KBD.Digit4, option: "4" },
        { disabled: true, text: "Supplier Reports", key: KBD.Digit5, option: "5" },
        { disabled: true, text: "Gift Cards", key: KBD.Digit6, option: "6" },
        { disabled: true, text: "Multi-store documents", key: KBD.Digit7, option: "7" },
        { disabled: true, text: "files in \\Reports directory", key: KBD.Digit8, option: "8" },
    ]

    const nav = [
        { key: KBD.ESCAPE, action: () => { setController("home") } },
        { key: KBD.ENTER, action: () => { 

           
            switch(selected){
                case "custom_inventory_reports":
                    switchView(selected)
                    break; 
                case "inventory_reports":
                    return; selectInventoryReport();
                break; 
            }

        } },
    ]

    useEffect(() => {
        const cleanup = listen(controller, route, nav);
        return cleanup;
    }, [nav, selected]);

    useEffect(() => { window.bm_state.value = route }, []);

    const drawMenu = () => {
        return (
            <div style={{ height: "calc(100vh - 74px)", minHeight: "600px", }} className="controller">
                <div style={{ "padding": "10px 15px" }}>
                    <Card style={{ "width": "800px" }} secondary header={<Label style={{ "textAlign": "left" }}>Report Areas</Label>}>
                        <Menu controller={controller} callback={(e) => switchView(e?.option)} bordered allow_keys keyName="option" show_keys setSelected={setSelected} selected={selected} menu={menu} route={route} />
                    </Card>
                </div>
            </div>
        )
    }


    const draw = () => {

        switch (state.view) {
            case "custom_inventory_reports":
                return <ReportsCustomInventory controller={controller} setController={setController} signal={signal} route={ROUTES.REPORTS.CUSTOM_INVENTORY} switchView={switchView} />
                break;
            case "inventory_reports":
                return <ReportsInventoryReportViewer state={state} controller={controller} setController={setController} signal={signal} route={ROUTES.REPORTS.INVENTORY_REPORT_VIEWER} switchView={switchView} />
                break;
            default:
                return drawMenu();
        }

    }

    return draw();

}


